export default {
  showPhysicians: true,
  allowPhysicianRegistration: true,
  showRealtors: false,
  refinerProjectId: 'b8256080-5749-11f0-a862-a7db130db598',
  allowAIJobSearch: true,
  posthogProjectToken: 'phc_wPDRNNUM9yn5EPjtpNpnNtHHjzZYxDHZyFREeEZHWP9d',
}
